import React from 'react'
import {Scrollbar} from 'react-scrollbars-custom'
import PropTypes from 'prop-types'
import ChatListItem from '#components/a/Chat/ChatListItem'

function ChatList({chatIds, onSelectChat, selectedChatId}) {
  return (
    <ul className="chat-list">
      <Scrollbar>
        {chatIds.map(chatId => (
          <ChatListItem
            key={chatId}
            id={chatId}
            onSelect={() => onSelectChat(chatId)}
            isSelected={chatId === selectedChatId}
          />
        ))}
      </Scrollbar>
    </ul>
  )
}

ChatList.propTypes = {
  chatIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectChat: PropTypes.func.isRequired,
  selectedChatId: PropTypes.string,
}

export default ChatList
